import {
   Box,
   Button,
   Checkbox,
   FormControl,
   Grid,
   IconButton,
   InputLabel,
   MenuItem,
   Paper,
   Radio,
   Select
} from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import BorderColorIcon from '@material-ui/icons/BorderColor'
import Tooltip from '@material-ui/core/Tooltip'
import isEqual from 'lodash/isEqual'
import { useHistory } from 'react-router-dom'

import PortalModal, { usePortalModal } from 'components/commons/PortalModal'

import homeIcon from 'images/components/reporter/HomeIcon.svg'
import previewQuestionnaireStyles from './styles'
import { useStateValue } from 'context/store'
import { userSettingsModule } from 'utils/utils'
import { getFromApi } from 'actions'
import { publishQuestAction } from 'context/reducers/QuestionariesReducer'
import { QUESTIONNAIRE } from '../constants'

const editPermission = userSettingsModule.buscarValorEnUserSettings(
   'operations',
   'EDITAR CUESTIONARIO'
)

function PreviewQuestionnaire({ setViewQuestionnarie, dataQuestionnaire }) {
   const [currenQuestion, setCurrentQuestion] = useState(1)
   const [{ questionaries }, dispatch] = useStateValue()
   const [totalQuestions, setTotalQuestions] = useState(1)
   const [currentDataQuestions, setCurrentDataQuestions] = useState([])
   const { params, onClose, setModal } = usePortalModal()

   const history = useHistory()

   const ITEMS_PER_QUESTION = 1
   const sortArrayByNumber = arr => {
      arr?.sort((a, b) => a?.number - b?.number)
      return arr
   }

   const mapQuestions = questionary => {
      if (questionary?.questions?.length) {
         setTotalQuestions(
            Math.ceil(questionary.questions.length / ITEMS_PER_QUESTION)
         )
         const questions = sortArrayByNumber(questionary?.questions)
         setCurrentDataQuestions(questions.slice(0, ITEMS_PER_QUESTION))
      }
   }

   const goToMundoMutual = () => history.push('/dashboard/mutual-world')

   const previewMode = questionaries?.questionaries?.previewMode

   const getDataQuestionnaire = async () => {
      try {
         if (!previewMode) {
            mapQuestions(questionaries)
         } else {
            const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/${questionaries.questionaries.id}`
            const ques = await getFromApi(url)
            mapQuestions(ques)
            dispatch({
               type: 'SaveQuest',
               questionaries: { ...ques, previewMode: true }
            })
         }
      } catch (error) {
         console.error('Error fetching questionnaire data:', error)
      }
   }
   const classes = previewQuestionnaireStyles()

   const goToNextQuetion = () => {
      setCurrentQuestion(question => question + 1)
   }

   const goToPreviousQuetion = () => {
      setCurrentQuestion(question => question - 1)
   }

   const goques = (goToEdit = true) => {
      if (!editPermission) {
         return
      }
      setViewQuestionnarie(
         goToEdit ? 'view-create-questionnaire' : 'view-search-questionnaire'
      )
   }
   const [selectedValue, setSelectedValue] = useState()

   const handleChange = event => {
      setSelectedValue(event.target.value)
   }

   const controlProps = item => ({
      checked: selectedValue == item,
      onChange: handleChange,
      value: item,
      name: 'color-radio-button-demo',
      inputProps: { 'aria-label': item }
   })
   const ListOption = () => (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'center',
            alignContent: 'center',
            width: '94%',
            gap: '1rem',
            marginBottom: '3rem'
            // padding: '2rem 0'
         }}
      >
         <FormControl
            variant="outlined"
            className={classes.formControlSelect}
            fullWidth
         >
            <InputLabel id="demo-s imple-select-label">
               Seleccionar tu respuesta
            </InputLabel>
            <Select
               select
               InputProps={{
                  classes: {
                     input: classes.root
                  }
               }}
               className={classes.selectInput}
               MenuProps={{ classes: { list: classes.list } }}
               variant="outlined"
               label="Seleccionar un formato"
               // value={value}
               // onChange={onChange}
               fullWidth
               classes={{
                  root: classes.root,
                  option: classes.option
               }}
            >
               {currentDataQuestions[0].answers.map((question, index) => (
                  <MenuItem
                     key={question.id || question.idVista}
                     value={question.id || question.idVista}
                     className={classes.boxItemSelect}
                  >
                     <CheckCircleIcon />
                     {question.valueAnswer}
                  </MenuItem>
               ))}
            </Select>
         </FormControl>
      </Box>
   )

   const SingleOption = () => (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'center',
            alignContent: 'center',
            width: '94%',
            gap: '1rem',
            marginBottom: '3rem'
            // padding: '2rem 0'
         }}
      >
         {currentDataQuestions[0].answers.map((question, index) => (
            <label
               key={question.id || question.idVista}
               className={classes.itemAsnwerBox}
            >
               <Radio
                  {...controlProps(question.id || question.idVista)}
                  color="primary"
               />
               <p>{question.valueAnswer}</p>
            </label>
         ))}
      </Box>
   )

   const MultipleOption = () => (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'center',
            alignContent: 'center',
            width: '94%',
            gap: '1rem',
            marginBottom: '3rem'
            // padding: '2rem 0'
         }}
      >
         {currentDataQuestions[0].answers.map(question => (
            <label
               key={question.id || question.idVista}
               className={classes.itemAsnwerBox}
            >
               <Checkbox color="primary" />
               <p>{question.valueAnswer}</p>
            </label>
         ))}
      </Box>
   )

   useEffect(() => {
      const fetchData = async () => {
         await getDataQuestionnaire()
      }
      fetchData()
   }, [])

   useEffect(() => {
      const begin = (currenQuestion - 1) * ITEMS_PER_QUESTION
      const end = begin + ITEMS_PER_QUESTION
      const questions = sortArrayByNumber(
         questionaries?.questionaries?.questions || questionaries?.questions
      )
      setCurrentDataQuestions(questions.slice(begin, end))
   }, [currenQuestion])

   useEffect(() => {
      isEqual(questionaries?.publishState, QUESTIONNAIRE.PUBLISHED_STATUS) &&
         setViewQuestionnarie('view-search-questionnaire')
   }, [questionaries])

   return (
      <div className={classes.container}>
         <div className={classes.buttonsNavigationsBox}>
            <div className={classes.buttonHome}>
               <img
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  src={homeIcon}
                  alt={'Inicio'}
                  onClick={() => {
                     previewMode
                        ? goToMundoMutual()
                        : setModal({
                             message:
                                'Señor usuario, usted detendrá la creación del cuestionario,  ¿Desea continuar?',
                             onConfirm: () => goToMundoMutual()
                          })
                  }}
               />
            </div>
            <div
               onClick={() => goques(!previewMode)}
               className={classes.iconArrowBack}
            >
               <ArrowBackIcon />
            </div>
         </div>

         <Paper className={classes.paper}>
            <div className={classes.boxLineDecoration}>
               <div style={{ backgroundColor: '#71BE4A', width: '10%' }} />
               <div style={{ backgroundColor: '#0098DF', width: '10%' }} />
            </div>
            <Grid style={{ width: '100%', margin: '0', padding: '0' }}>
               <div className={classes.boxInfo}>
                  <h4>{questionaries?.questionaries?.name}</h4>
                  <p>{questionaries?.questionaries?.description}</p>
               </div>
            </Grid>

            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                  margin: '2rem 0 1rem 0',
                  width: '94%'
                  // padding: '2rem 0'
               }}
            >
               <h3
                  style={{
                     margin: '4px 0 0 0',
                     padding: '0'
                  }}
               >
                  {currenQuestion}. {currentDataQuestions[0]?.question}
               </h3>
               <div>
                  <Tooltip title="EDITAR PREGUNTA" placement="top" arrow>
                     <IconButton
                        size="small"
                        style={{ background: 'transparent' }}
                        onClick={() => goques()}
                        disabled={
                           !editPermission ||
                           isEqual(
                              questionaries?.questionaries?.status,
                              QUESTIONNAIRE.PUBLISHED_STATUS
                           )
                        }
                     >
                        <div className={classes.iconPincel}>
                           <BorderColorIcon />
                        </div>
                     </IconButton>
                  </Tooltip>
               </div>
            </Box>

            {currentDataQuestions?.map((question, index) => {
               if (
                  question.questionType?.id === 3 ||
                  question.questionType?.idVista === 3
               ) {
                  return <ListOption key={index} />
               }
               if (
                  question.questionType?.id === 1 ||
                  question.questionType?.idVista === 3
               ) {
                  return <SingleOption key={index} />
               }
               if (
                  question.questionType?.id === 2 ||
                  question.questionType?.idVista === 3
               ) {
                  return <MultipleOption key={index} />
               }
            })}

            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  height: '70px',
                  width: '100%',
                  marginTop: '2rem',
                  background: '#A7B0C61A 0% 0% no-repeat'
               }}
            >
               <div className={classes.boxFooterPaper}>
                  <div />
                  <Button
                     className={classes.buttonReadyAnswer}
                     size="large"
                     variant="contained"
                     color="primary"
                     onClick={() => {
                        dispatch(
                           publishQuestAction(questionaries?.questionaries)
                        )
                     }}
                  >
                     Publicar
                  </Button>
                  <div className={classes.boxButtonFotterNavigation}>
                     {currenQuestion > 1 ? (
                        <div
                           className={classes.iconArrowBack2}
                           onClick={goToPreviousQuetion}
                        >
                           <ArrowBackIcon />
                        </div>
                     ) : (
                        <div />
                     )}
                     {totalQuestions === currenQuestion ? (
                        <div />
                     ) : (
                        <div
                           className={classes.iconArrowBack2}
                           onClick={goToNextQuetion}
                        >
                           <ArrowForwardIcon />
                        </div>
                     )}
                  </div>
               </div>
            </Box>
            <PortalModal params={params} onClose={onClose} />
         </Paper>
      </div>
   )
}

export default PreviewQuestionnaire
